<template>
    <div v-if="cohort">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-6">
                    <platform-cohorts :cohort="cohort" @ready="ready = true" @change="changed"></platform-cohorts>
                </div>
                <div class="col-6">
                    <cohort-children :cohort="cohort" :ready="ready" @change="changed"></cohort-children>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PlatformCohorts from './cohorts/PlatformCohorts'
    import CohortChildren from './cohorts/CohortChildren'

    export default {

        components: {
            PlatformCohorts, CohortChildren
        },

        data() {
            return {
                cohort: null,
                ready : false,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.cohorts'),
                        route: '/astral/ui/accounts/cohorts'
                    },
                    {
                        name: this.cohort.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/astral/api/front/cohorts/'+to.params.id, {params: {
                relations: ['children'],
                accessors: ['all_members', 'has_registrations'],
            }})
            .then(resp => {
                next(vm => {
                    vm.cohort = resp.data.data
                })
            })
        },

        methods: {
            changed() {
                axios.get('/astral/api/front/cohorts/'+this.$route.params.id, {params: {
                    relations: ['children'],
                    accessors: ['all_members', 'has_registrations'],
                }})
                .then(resp => {
                    this.cohort = resp.data.data
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
